export function buildScheduleForm(action: string, emailChainId: string, date: string, subject: string, body: string) {
  // create outer div
  const div = document.createElement('div');
  div.className = `schedule-${emailChainId}`;

  // create form element
  const form = document.createElement('form');
  form.className = 'simple_form schedule-contact with-ajax-notice';
  form.id = `edit_email_chain_${emailChainId}`;
  form.action = action;
  form.acceptCharset = 'UTF-8';
  form.setAttribute('data-remote', 'true');
  form.method = 'post';
  form.setAttribute('data-hs-cf-bound', 'true');

  // create date field
  const dateGroup = document.createElement('div');
  dateGroup.className = 'form-group string optional email_chain_scheduled_auto_response_follow_up_at';

  const dateLabel = document.createElement('label');
  dateLabel.className = 'control-label string optional font-weight-bold my-2';
  dateLabel.htmlFor = 'email_chain_scheduled_auto_response_follow_up_at';
  dateLabel.textContent = 'Date';

  const dateInput = document.createElement('input');
  dateInput.className = 'form-control string optional schedule-date hidden-block';
  dateInput.type = 'text';
  dateInput.name = 'email_chain[scheduled_auto_response_follow_up_at]';
  dateInput.id = 'email_chain_scheduled_auto_response_follow_up_at';

  if (date) dateInput.value = date;
  dateGroup.appendChild(dateLabel);
  dateGroup.appendChild(dateInput);
  form.appendChild(dateGroup);

  // create subject field
  const subjectGroup = document.createElement('div');
  subjectGroup.className = 'form-group string optional email_chain_follow_up_subject mt-2';

  const subjectLabel = document.createElement('label');
  subjectLabel.className = 'control-label string optional font-weight-bold my-2';
  subjectLabel.htmlFor = 'email_chain_follow_up_subject';
  subjectLabel.textContent = 'Subject';

  const subjectInput = document.createElement('input');
  subjectInput.className = 'form-control string optional';
  subjectInput.type = 'text';
  subjectInput.name = 'email_chain[follow_up_subject]';
  subjectInput.id = 'email_chain_follow_up_subject';

  if (subject) subjectInput.value = subject;
  subjectGroup.appendChild(subjectLabel);
  subjectGroup.appendChild(subjectInput);
  form.appendChild(subjectGroup);

  // create body textarea
  const bodyGroup = document.createElement('div');
  bodyGroup.className = 'form-group text optional email_chain_follow_up_body mt-2';

  const bodyLabel = document.createElement('label');
  bodyLabel.className = 'control-label text optional font-weight-bold my-2';
  bodyLabel.htmlFor = 'email_chain_follow_up_body';
  bodyLabel.textContent = 'Body';

  const bodyTextarea = document.createElement('textarea');
  bodyTextarea.className = 'form-control text optional summernote mt-2';
  bodyTextarea.name = 'email_chain[follow_up_body]';
  bodyTextarea.id = 'email_chain_follow_up_body';

  if (body) bodyTextarea.value = body;
  bodyGroup.appendChild(bodyLabel);
  bodyGroup.appendChild(bodyTextarea);
  form.appendChild(bodyGroup);

  // create button container
  const buttonContainer = document.createElement('div');
  buttonContainer.className = 'd-flex justify-content-end mb-3';

  // create AI Draft button
  const aiButton = document.createElement('button');
  aiButton.type = 'button';
  aiButton.className = 'btn btn-secondary ai-draft-button';
  aiButton.setAttribute('data-email-chain-id', emailChainId);

  const aiIcon = document.createElement('i');
  aiIcon.className = 'fas fa-robot';
  aiButton.appendChild(aiIcon);
  aiButton.appendChild(document.createTextNode(' AI Draft Response'));
  buttonContainer.appendChild(aiButton);

  // create submit button
  const submitButton = document.createElement('input');
  submitButton.type = 'submit';
  submitButton.name = 'commit';
  submitButton.value = 'Save';
  submitButton.className = 'btn btn-primary ml-2 right-aligned submit-schedule';
  submitButton.setAttribute('data-disable-with', 'Save');
  buttonContainer.appendChild(submitButton);

  form.appendChild(buttonContainer);
  div.appendChild(form);

  return div;
}
